import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { Flex } from "#shared/view/components/Flex";
import { PriceInputController } from "#shared/view/components/PriceInputController";
import { NumberInputController } from "#shared/view/designSystem/inputs/NumberInputController";
import { ProductLine } from "shared";

export const ConsumableData = ({
  onConsumableDataChange,
  productLines,
}: {
  onConsumableDataChange: ({
    id,
    payload,
  }: {
    id: string;
    payload: {
      quantity: number;
      name: string;
      price: number;
    };
  }) => void;
  productLines: ProductLine[];
}) => {
  const { t } = useTranslation();

  const { control } = useFormContext<QuoteRequestLineFormData>();

  const productLine = productLines[0];

  return (
    <Flex gap="xs">
      <NumberInputController
        control={control}
        name="quantity"
        label={t("qrl.quantity")}
        value={productLine?.quantity}
        onValueChange={(value) => {
          if (!productLine?.id) {
            return;
          }

          onConsumableDataChange({
            id: productLine.id,
            payload: {
              quantity: value.floatValue ?? 0,
              name: productLine.name,
              price: productLine.price,
            },
          });
        }}
      />
      <PriceInputController
        control={control}
        name="productLines.0.price"
        label={t("qrl.consumable.price")}
        onChange={(value) => {
          if (!productLine?.id) {
            return;
          }

          onConsumableDataChange({
            id: productLine.id,
            payload: {
              quantity: productLine.quantity,
              name: productLine.name,
              price: (value as number) * 100,
            },
          });
        }}
      />
    </Flex>
  );
};
